import { Box } from '@mui/material';
import { GridToolbarColumnsButton, GridToolbarProps } from '@mui/x-data-grid-pro';

// Custom toolbar with only the columns button
export const ColumnsOnlyToolbar = (props: GridToolbarProps) => (
  <Box sx={{ paddingTop: 2, px: 3 }} {...props}>
    <GridToolbarColumnsButton
      slotProps={{
        button: {
          sx: {
            textTransform: 'none',
            padding: '4px 5px',
          },
        },
      }}
    />
  </Box>
);
